import React from 'react';
import PropTypes from 'prop-types';

function CircleIcon({ className, fill, width }) {
  return (
  <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
	 width={width} viewBox="0 0 29.334 29.334"
	 xmlSpace="preserve">
    <g>
      <path d="M14.666,0C6.578,0,0,6.58,0,14.668c0,8.087,6.578,14.666,14.666,14.666s14.668-6.579,14.668-14.666
        C29.334,6.58,22.754,0,14.666,0z M14.666,25.334C8.784,25.334,4,20.549,4,14.668C4,8.785,8.784,4,14.666,4
        c5.883,0,10.668,4.785,10.668,10.668C25.334,20.549,20.547,25.334,14.666,25.334z"/>
    </g>
    </svg>
  );
}
CircleIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.string,
};

CircleIcon.defaultProps = {
  fill: '#000000',
  width: '12',
  className: 'icon-circle',
};

export default CircleIcon;